<script setup lang="ts">

interface AccordionProps {
  title?: string,
  open?: boolean,
}

const {title = "Title", open = false} = defineProps<AccordionProps>()

const isActive = ref(open);
const accordionBodyRef = ref(null);
const accordionBodyHeight = ref(0);

onMounted(() => {
  if (accordionBodyRef.value) {
    accordionBodyHeight.value = accordionBodyRef.value.clientHeight;
  }
})

const toggleItem = (event) => {
  event.preventDefault();
  // bodyStyle.marginTop = !isActive.value ? "0" : "-" + accordionBodyHeight.value + "px";
  isActive.value = !isActive.value;
}

const beforeStart = (el) => {
  el.style.marginTop = "-" + el.scrollHeight + "px";
  el.style.transition = "margin-top 0s";
}

const start = (el) => {
  el.style.marginTop = "-" + el.scrollHeight + "px";
  el.style.transition = "margin-top .3s";
}

const end = (el) => {
  el.style.marginTop = "";
  el.style.transition = "margin-top .3s";
}

</script>

<template>
  <div class="accordion">
    <button
      class="accordion__head"
      @click="toggleItem"
    >
      <span class="title">
        {{ title }}
      </span>
      <span
        class="arrow"
        :class="{ active: isActive }"
      >
        <svg
          width="12"
          height="8"
          viewBox="0 0 12 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1 1L6 6L11 1"
            stroke="#2D2D86"
            stroke-width="2"
            stroke-linecap="round"
          />
        </svg>
      </span>
    </button>

    <transition
      name="accordion"
      @enter="beforeStart"
      @after-enter="end"
      @before-leave="start"
      @after-leave="start"
    >
      <div
        v-show="isActive"
        class="accordion__body active"
      >
        <slot />
      </div>
    </transition>
  </div>
</template>

<style lang="scss" scoped>

.accordion {
  border-radius: 10px;
  border: 1px solid rgba(45, 45, 134, 0.20);
  overflow: hidden;
  background: #fff;

  &__head {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    background: #fff;
    padding: 20px;

    .title {
      color: var(--text-color, #1F163B);
      font-size: 14px;
      font-weight: 700;
    }

    .arrow {
      transform: none;
      transition: transform .3s;

      &.active {
        transform: rotate(180deg);
      }
    }
  }

  &__body {
    position: relative;
    padding: 0 20px 20px;
    margin-top: 0;
    transition: margin .3s, opacity .3s, visibility .3s;
  }
}
</style>
